import { faEdit, faTrashCan, faBars } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { useEffect, useState } from 'react'
import { Draggable, Droppable } from 'react-beautiful-dnd'
import { ICategory } from '../../../../types/categories'
import ConfirmDialog from '../../../../components/confirm-dialog/ConfirmDialog'

type Props = {
  categories: ICategory[]
  handleDelete: (id: string) => void
  handleEdit: (category: ICategory) => void
}
const c = 'categories-page'

const DropComponent = (props: Props) => {
  const [enabled, setEnabled] = useState(false)
  const [confirmDeleteId, setConfirmDeleteId] = useState<string | null>(null)
  const [confirmEditCategory, setConfirmEditCategory] =
    useState<ICategory | null>(null)

  useEffect(() => {
    const animation = requestAnimationFrame(() => setEnabled(true))

    return () => {
      cancelAnimationFrame(animation)
      setEnabled(false)
    }
  }, [])

  if (!enabled) {
    return null
  }

  const categoryToDelete = props.categories.find(
    (c) => c._id === confirmDeleteId,
  )

  return (
    <>
      <Droppable droppableId='categories'>
        {(provided) => (
          <div
            className={`${c}__categories`}
            {...provided.droppableProps}
            ref={provided.innerRef}
          >
            {props.categories.map((category, index) => {
              return (
                <Draggable
                  key={category._id}
                  draggableId={category._id}
                  index={index}
                >
                  {(provided) => (
                    <div
                      key={category._id}
                      className={`${c}__categories-item`}
                      ref={provided.innerRef}
                      {...provided.draggableProps}
                    >
                      <div
                        className={`${c}__categories-item-drag`}
                        {...provided.dragHandleProps}
                      >
                        <FontAwesomeIcon icon={faBars} />
                      </div>
                      <div className={`${c}__categories-item-title`}>
                        {category.name}
                        {category.ru_name && (
                          <span className={`${c}__categories-item-title-ru`}>
                            {' '}
                            / {category.ru_name}
                          </span>
                        )}
                      </div>
                      <div className={`${c}__categories-item-actions`}>
                        <button
                          className={`${c}__categories-item-actions-btn edit`}
                          onClick={() => setConfirmEditCategory(category)}
                          title='Editează'
                        >
                          <FontAwesomeIcon icon={faEdit} />
                        </button>
                        <button
                          className={`${c}__categories-item-actions-btn delete`}
                          onClick={() => setConfirmDeleteId(category._id)}
                          title='Șterge'
                        >
                          <FontAwesomeIcon icon={faTrashCan} />
                        </button>
                      </div>
                    </div>
                  )}
                </Draggable>
              )
            })}
            {provided.placeholder}
          </div>
        )}
      </Droppable>

      <ConfirmDialog
        open={!!confirmDeleteId}
        title='Șterge categorie'
        message={`Ești sigur că vrei să ștergi "${categoryToDelete?.name}"? Această acțiune este ireversibilă.`}
        onConfirm={() => {
          if (confirmDeleteId) props.handleDelete(confirmDeleteId)
          setConfirmDeleteId(null)
        }}
        onCancel={() => setConfirmDeleteId(null)}
      />

      <ConfirmDialog
        open={!!confirmEditCategory}
        title='Editează categorie'
        message={`Ești sigur că vrei să editezi "${confirmEditCategory?.name}"?`}
        onConfirm={() => {
          if (confirmEditCategory) props.handleEdit(confirmEditCategory)
          setConfirmEditCategory(null)
        }}
        onCancel={() => setConfirmEditCategory(null)}
      />
    </>
  )
}

export default DropComponent
